<script>
  import { mapGetters, mapActions } from 'vuex'
  import * as Helper from '@/modules/helper/index'
  export default {
    computed: {
      ...mapGetters([
        'TeamMember',
        'MainMenuLayout',
        'resource'
      ]),
      SubscriptionModuleId() {
        return this.$f7route.params.Id
      },
      headerElements() {
        let teamData = this.TeamMember
        let headerElements
        if (teamData.Parent.HeaderElements) {
          headerElements = JSON.parse(teamData.Parent.HeaderElements)
        }
        return headerElements
      },
      footerElements() {
        let teamData = this.TeamMember
        let footerElements
        if (teamData.Parent.FooterElements) {
          footerElements = JSON.parse(teamData.Parent.FooterElements)
        }
        return footerElements
      }
    },
    methods: {
      ...mapActions([
        'loadLocalTeamData',
        'loadTeam'
      ]),
      initTeamModule(SubscriptionModuleId) {
        this.$showLoader()
        this.loadLocalTeamData(SubscriptionModuleId)
        this.loadTeam(SubscriptionModuleId).then(() => {
          this.$hideLoader()
          this.$RegisterPageView({'SubscriptionModule_Id': SubscriptionModuleId, 'ContentGUID': this.TeamMember.Parent.Id, 'ViewType': 1})
        }).catch(err => {
          console.log('err', err)
          this.$hideLoader()
        })
      },
      isNullOrEmpty: function(value) {
        return Helper.IsNullOrEmpty(value)
      }
    },
    created() {
      this.initTeamModule(this.SubscriptionModuleId)
    },
    mounted() {
      if (this.$refs.teamPage) {
        this.$refs.teamPage.$on('page:reinit', (event, payload) => {
          this.initTeamModule(this.SubscriptionModuleId)
        })
      }
    },
    beforeDestroy() {
      if (this.$refs.teamPage) {
        this.$refs.teamPage.$off('page:reinit', (event, payload) => {
          this.initTeamModule(this.SubscriptionModuleId)
        })
      }
    }
  }
</script>
<template>
  <f7-page ref="teamPage" :page-content="false" name="team-view" v-if="TeamMember">
    <!-- Header View Component -->
    <app-header :header="TeamMember.Parent.PageTitle"></app-header>
    <!-- Menu View Component  -->
    <app-tab-menu v-if="MainMenuLayout === 1"></app-tab-menu>
    <!-- <app-side-menu v-if="MainMenuLayout === 2"></app-side-menu> -->
    <!-- Page content View -->
    <div class="backgroundimg"></div>
    <f7-page-content>
      <div v-if="headerElements" class="header-section">
        <component v-for="(el,index) in headerElements.elements" :is="'app-' + el.elementType" :key="index" v-bind="el.properties">
        </component>
      </div>
      <f7-card v-for="(Person, index) in TeamMember.Persons" :key="index">
        <f7-card-header class="avatar-content no-border">
          <f7-col class="avatar">
            <app-circular-image :isShowDefalut="isNullOrEmpty(Person.PersonImage)" :imageName="Person.PersonImage">
            </app-circular-image>
          </f7-col>
          <f7-col class="avatar-title">{{Person.PersonName}}</f7-col>
          <f7-col class="avatar-sub-title">
            <a href="#">{{Person.PersonPosition}}</a>
          </f7-col>
        </f7-card-header>
        <f7-card-content v-if="!isNullOrEmpty(Person.PersonDescription)" class="person-desc">{{Person.PersonDescription}}</f7-card-content>
        <f7-card-footer v-if="!isNullOrEmpty(Person.Phone) || !isNullOrEmpty(Person.Email)">
          <f7-link v-tel="Person.Phone" v-if="!isNullOrEmpty(Person.Phone)" class="external">{{resource.startCall}}</f7-link>
          <f7-link v-mailto="Person.Email" v-if="!isNullOrEmpty(Person.Email)" class="external">{{resource.sendMail}}</f7-link>
        </f7-card-footer>
      </f7-card>
    
      <div v-if="footerElements" class="footer-section">
        <component v-for="(el,index) in footerElements.elements" :is="'app-' + el.elementType" :key="index" v-bind="el.properties">
        </component>
      </div>
    </f7-page-content>
  </f7-page>
</template>
<style scoped>
  .card-header{
    min-height: 6em!important;
  }
  .person-desc {
    /* word-break: break-all; */
  }
</style>



// WEBPACK FOOTER //
// src/components/team-member/TeamMember.vue